
import api from './api'

import { useDownload } from '@/helpers/download'

export default {
    
    count(params = {}) {
        return api.get('/stats', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/stats/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },      

    list(params = {}) {

        return api.get('/stats', { params })
            .then( json => json.data.articleStats )
    },

    search(params = {}) {
        return api.get('/stats', { params })
            .then( json => json.data.articleStats )            
    } 
}
